import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Link,
  Paper,
  Typography,
} from '@gogame/components';

import Status from 'scenes/PromoCodes/components/Status';
import PromoCodeDetails from 'scenes/PromoCodes/components/PromoCodeDetails';


export default ({ data, openChildComponent }) => {
  const handleOpenPromoCode = () => {
    openChildComponent(PromoCodeDetails, {
      id: data.promoCodeId,
    });
  };
  return {
    color: 'payment',
    date: data?.redemptionDate,
    title: (
      <Typography>
        <span>Promo code - </span>
        <Link onClick={handleOpenPromoCode}>{data?.promoCodeName}</Link>
      </Typography>
    ),
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem label={'Promo code ID'} field={'promoCodeId'} />
          <DescriptionItem
            label={'Activity Type'}
            field={'promoCodeActivityType'}
          />
          <DescriptionItem
            label={'Expiration Date'}
            field={'promoCodeExpirationDate'}
            template={'LL'}
            type={'date'}
            timeZone={'utc'}
          />
          <DescriptionItem
            label={'Status'}
            field={'promoCodeStatus'}
            type={'status'}
            statusFactory={Status}
          />
          <DescriptionItem
            label={'Associated account UID'}
            field={'associatedAccountUid'}
          />
        </DescriptionList>
      </Paper>
    ),
  };
};
